/** Build compact bank reference: INV-12,34 (INV- prefix once). */
export const buildCompactInvoiceReference = (invoiceIds: number[]): string => {
  if (invoiceIds.length === 0) return "";
  return `INV-${invoiceIds.join(",")}`;
};

export const sumInvoiceAmounts = (
  amounts: Array<{ amount: number }>,
): number =>
  amounts.reduce(
    (sum, inv) => sum + (Number.isFinite(inv.amount) ? inv.amount : 0),
    0,
  );

export const MULTI_INVOICE_PAYMENT_TIP =
  "Paying more than one invoice? Use one reference with all invoice numbers after INV-, separated by commas — for example INV-12,34 — and pay the combined total.";
